import React from 'react'
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import Quizz from '../components/quizz/Quizz';
import QuizzForm from '../components/quizz/QuizzForm';
import Error from '../components/ui/Error';
import Loader from '../components/ui/Loader';
import Navbar from '../components/ui/Navbar'
import { useGetQuizzesQuery } from '../features/quizzes/quizzesApi';
import { toggleQuizzModal } from '../features/quizzes/quizzesSlice';

function Quizzes() {
	//States
	const { isQuizzModalOpen } = useSelector((state) => state.quizzes);
	const { data: quizzes, isLoading, isError } = useGetQuizzesQuery() || {};
	const dispatch = useDispatch();

	//Functions
	const handleModal = () => {
		dispatch(toggleQuizzModal(!isQuizzModalOpen))
	}

	//Decide what to render
	let content = null;

	if (isLoading) {
		content = <Loader />
	}
	if (!isLoading && isError) {
		content = <Error message="There was an error occured!" />
	}
	if (!isLoading && !isError && quizzes.length === 0) {
		content = <div className='text-center'>No Quiz Found</div>
	}
	if (!isLoading && !isError && quizzes.length > 0) {
		content = (
			<div className="overflow-x-auto mt-4">
				<table className="divide-y-1 text-base divide-gray-600 w-full">
					<thead>
						<tr>
							<th className="table-th">Question</th>
							<th className="table-th">Video</th>
							<th className="table-th justify-center">Action</th>
						</tr>
					</thead>

					<tbody className="divide-y divide-slate-600/50">
						{quizzes.map((quizz) => (<Quizz key={quizz.id} quizz={quizz} />))}
					</tbody>
				</table>
			</div>
		);
	}


	return (
		<>
			<Helmet>
				<title>Quizzes</title>
			</Helmet>
			<Navbar />
			<section className="py-6 bg-primary">
				<div className="mx-auto max-w-full px-5 lg:px-20">
					<div className="px-3 py-20 bg-opacity-10">
						<div className="w-full flex">
							<button className="btn ml-auto" onClick={handleModal}>Add Quiz</button>
						</div>
						{content}
					</div>
				</div>
			</section>
			{isQuizzModalOpen && <QuizzForm />}
		</>
	)
}

export default Quizzes